import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import OrderCard from "./OrderCard";
import { Order } from "@/types/ApiTypes";

interface Props {
    order: Order;
    title: string
}

export default function SortableOrderCard({ order, title }: Props) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: order._id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        touchAction: "none", // ✅ Important for mobile support
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
            <OrderCard order={order} title={title} isDragging={isDragging} />
        </div>
    );
}
